
function guardMyroute(to, from, next) {
    var isAuthenticated = false;
    //this is just an example. You will have to find a better or
    // centralised way to handle you localstorage data handling
    if (localStorage.getItem('access_token') && localStorage.getItem('moduleList') != null && localStorage.getItem('moduleList') != "") {
        isAuthenticated = true;
    }
    else {
        isAuthenticated = false;
    }
    if (isAuthenticated) {
        let moduleList = JSON.parse(localStorage.getItem('moduleList'))
        let result = moduleList.findIndex(module => module.moduleCode == to.meta.moduleCode);
        
        if (result != -1 || to.name == 'Dashboard' || to.name == 'My Profile' || to.name =='Manage Assets | Asset Detial View ' ) {

            next(); // allow to enter route
        } else {
            next('/dashboard')
        }
    } else {
        next('/login'); // go to '/login';
        location.replace("/login");
    }
}

function LoginGuard(to, from, next) {
    if (!localStorage.getItem('access_token')) {
        next(); // allow to enter route
    } else {
        next('/dashboard');
    }
}

export default {
    LoginGuard,
    guardMyroute
    }